import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const boolCastUiNodeSpec: UiNodeSpec<'boolCast'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: {}, id: getUID(), kind: 'boolCast', disabled: false }),
    controls: () => ({}),
    inputs: () => ({ input: { socket: 'varValue', label: 'Input' } }),
    kindLabel: 'Boolean Value Cast',
    nodeCategory: 'boolean',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
